export default class MainController {
    constructor($sce, $equalOneUIService, $customFieldsService) {
        var ctrl = this;
        ctrl.$equalOneUIService = $equalOneUIService;
        ctrl.hasCustomFields = $customFieldsService.hasCustomFields();

        ctrl.chartLink = undefined;

        ctrl.showChart = function (link) {
            $('#mschartloading').show();

            ctrl.chartLink = $sce.trustAsResourceUrl(link);
            $('#mschart').one("load", function(){
                $('#mschartloading').hide();
                $('#mschart').show();
            });
        }

        ctrl.clearChart = function () {
            ctrl.chartLink = undefined;
            $('#mschart').hide();
        }
    }
}

MainController.$inject = ['$sce', 'EQualOneUIService', 'CustomFieldsService'];


// WEBPACK FOOTER //
// ./src/main/MainController.js